import { SetMyCreditCardRequest } from 'vopay';
import { useState } from 'react';
import { useApi } from '#shared/providers/Api';

export default function useSetClientCreditCard() {
  const api = useApi();
  const [saving, setSaving] = useState(false);

  async function setClientCreditCard(params: SetMyCreditCardRequest) {
    try {
      setSaving(true);
      const res = await api.postSetClientMyCreditCard(params);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      return res;
    } catch (error) {
      console.error(error);
      throw error;
    } finally {
      setSaving(false);
    }
  }

  return { saving, setClientCreditCard };
}
